import styled from '@emotion/styled'
import React, { ComponentProps, ReactNode } from 'react'

import { Link } from '@emico/link'
import { overrideOptional } from '@emico/overrides'
import { theme, minWidth } from '@emico/styles'

import Container from './Container'
import Logo from './Logo'

const StyledNavigationBar = styled.div`
  background: ${theme.backgroundColor};
  border-bottom: 1px solid ${theme.gray500};
`

const StyledContainer = styled(Container)`
  display: flex;
  flex-flow: row wrap;
`

const ContentCol = styled.div`
  display: flex;
  align-items: center;
  min-height: 60px;
  flex: 1 0 calc(100% / 12 * 8);

  @media ${minWidth('md')} {
    flex-basis: calc(100% / 12 * 5);
  }
`

const LogoCol = styled(ContentCol)`
  text-align: center;
  fill: ${theme.primary500};
  flex: 0 0 calc(100% / 12 * 4);

  svg {
    width: 100%;
  }

  @media ${minWidth('md')} {
    flex-basis: calc(100% / 12 * 2);
  }
`

const ActionsCol = styled(ContentCol)`
  text-align: right;
  justify-content: flex-end;
  flex: 0 0 100%;

  @media ${minWidth('md')} {
    flex-basis: calc(100% / 12 * 5);
  }
`

interface Props
  extends Omit<ComponentProps<typeof StyledNavigationBar>, 'children'> {
  children: ReactNode
  actions: ReactNode
}

const NavigationBar = ({ children, actions, ...others }: Props) => (
  <StyledNavigationBar {...others}>
    <StyledContainer noPadding>
      <LogoCol>
        <Link to="/" analyticsName="Home" analyticsContext="header.logo">
          <Logo />
        </Link>
      </LogoCol>

      <ContentCol>{children}</ContentCol>

      <ActionsCol>{actions}</ActionsCol>
    </StyledContainer>
  </StyledNavigationBar>
)

export default overrideOptional(NavigationBar)
